import BrowserLogger from 'alife-logger';
import getGlobalParams from '@module/helper/changba-global-params';

const isProduction = process.env.NODE_ENV === 'production';

const emptyFunction = () => {};

const defaultConfig = {
  pid: 'fgw29hkkce@a8e8dceb20f33ee',
  appType: 'web',
  imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
  sendResource: true,
  enableLinkTrace: true,
  behavior: true,
  useFmp: true,
  enableSPA: true,
  parseHash: (hash) => {
    const page = hash ? hash.replace(/^#/, '').replace(/\?.*$/, '') : '';
    return page || location.pathname;
  },
  ignore: {
    ignoreErrors: [
      /setShareUrlParams/,
      /__changbaPageHideCallback/,
      /^Script error\.?$/
    ]
  },
  environment: isProduction ? 'prod' : 'local'
}

export default async function initializeBrowserLogger({ projectName, developmentDisabled = true }, options = {}) {
  if (!isProduction && developmentDisabled) {
    return {
      setConfig: emptyFunction,
      api: emptyFunction,
      error: emptyFunction,
      speed: emptyFunction,
      sum: emptyFunction,
      avg: emptyFunction,
      resource: emptyFunction,
      event: emptyFunction,
      setPage: emptyFunction,
      setCommonInfo: emptyFunction,
      custom: emptyFunction
    };
  }

  const globalParams = await getGlobalParams();

  const config = {
    ...defaultConfig,
    uid: globalParams.userId,
    c1: globalParams.appVersion,
    release: globalParams.appVersion,
    tag: projectName,
    ...options
  };

  return BrowserLogger.singleton(config);
};
